export interface LevelSummaryExitConfig {
  destination: string
  requireConfirmation: boolean
  xAndSecondaryExitShareAction: boolean
}

export function getLevelSummaryExitConfig(): LevelSummaryExitConfig {
  return {
    destination: '/jornadas',
    requireConfirmation: false,
    xAndSecondaryExitShareAction: true
  }
}
